import Component from "../../../../js/assets/component.js"

class LpTitle extends Component {
  constructor(el){
    super(el)
  }

  activate(){
    this.$el.removeClass("-inActive")
    this.$el.addClass("-active")
  }

  inActivate(){
    this.$el.removeClass("-active")
    this.$el.addClass("-inActive")
  }
}

export default LpTitle
